import styled from 'styled-components';

// const px = (px: number) => (px / 800) * 600 + 'px';

interface Props {
	factor: number;
}

export const InfoGraphicHowItWorksContainer = styled.div`
	position: relative;
	flex-shrink: 1;

	width: 600px;
	height: auto;

	aspect-ratio: 1.3 / 1;

	--padding: ${({ factor }: Props) => factor * 14 + 'px'};

	--step-size: ${({ factor }: Props) => factor * 140 + 'px'};
	--step-end-size: ${({ factor }: Props) => factor * 211 + 'px'};

	--stack-color: rgba(255, 255, 255, 0.01);
	--stack-width: ${({ factor }: Props) => factor * 80 + 'px'};

	.step {
		position: absolute;
		z-index: 10;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		width: var(--step-size);
		height: var(--step-size);

		background: var(--color-surface);
		border-radius: 50%;

		.step-content {
			position: absolute;
			z-index: 100;
			top: 0;
			left: 0;

			width: 100%;
			height: 100%;

			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: ${({ factor }: Props) => factor * 8 + 'px'};

			background: var(--color-surface);
			border-radius: 50%;

			span {
				font-size: ${({ factor }: Props) => factor * 17 + 'px'};
				font-weight: 300;
				opacity: 0.8;
			}

			svg {
				width: ${({ factor }: Props) => factor * 40 + 'px'};
				height: ${({ factor }: Props) => factor * 40 + 'px'};
				object-fit: contain;
			}
		}

		&.step-one {
			bottom: var(--padding);
			left: 50%;
			transform: translateX(-50%);
		}

		&.step-two {
			left: var(--padding);
			top: 50%;
			transform: translateY(-50%);
		}

		&.step-three {
			top: var(--padding);
			left: 50%;
			transform: translateX(-50%);
		}

		&.step-four {
			right: var(--padding);
			top: 50%;
			transform: translateY(-50%);
		}

		&.step:not(.step-end) {
			z-index: 10;

			&::before {
				--n: 20; /* control the number of dashes */
				--d: 8deg; /* control the distance between dashes */
				--t: 5px; /* control the thickness of border*/
				--c: red; /* control the coloration (can be a gradient) */

				content: '';
				position: absolute;
				top: 50%;
				/* left: 50%; */
				transform: translate(-50%, -50%);

				width: calc(100% + calc(var(--padding) * 2));
				height: calc(100% + calc(var(--padding) * 2));
				margin: auto;

				border-radius: 50% !important;
				border: 2px dashed var(--color-surface);

				animation: rotate 16s linear 0s infinite normal forwards;
				pointer-events: none;

				background: var(--color-background);
			}
		}

		&.design,
		&.testing {
			width: calc(var(--step-size) * 1.2);
			height: calc(var(--step-size) * 1.2);

			.step-content {
				background: #fff;
				color: rgba(0, 0, 0, 0.8);

				span {
					opacity: 1 !important;
					font-weight: 400 !important;
					font-size: ${({ factor }: Props) =>
						factor * 18 + 'px'} !important;
				}

				svg {
					width: ${({ factor }: Props) =>
						factor * 46 + 'px'} !important;
					height: ${({ factor }: Props) =>
						factor * 46 + 'px'} !important;
				}
			}

			&::before {
				border-color: #fff !important;
			}
		}

		&.step-end {
			position: relative;
			width: var(--step-end-size);
			height: var(--step-end-size);
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			background: var(--color-surface);

			border: ${({ factor }: Props) => factor * 10 + 'px'} groove #fff;

			span {
				opacity: 1;
			}

			svg {
				color: #fff;
				width: ${({ factor }: Props) => factor * 56 + 'px'};
				height: ${({ factor }: Props) => factor * 56 + 'px'};
			}
		}
	}

	.stack {
		--stack-one-bg: var(--stack-color);
		--stack-two-bg: var(--stack-color);
		--stack-three-bg: var(--stack-color);

		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		width: calc(var(--step-end-size) + calc(var(--stack-width) * 1));
		height: calc(var(--step-end-size) + calc(var(--stack-width) * 1));

		background: var(--stack-one-bg);
		border-radius: 50%;

		animation: stacks 3s linear 1s infinite backwards;
		/* animation: stacks .5s linear 0s infinite alternate forwards; */

		&::before {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);

			width: calc(100% + calc(var(--stack-width) * 0.9));
			height: calc(100% + calc(var(--stack-width) * 0.9));

			background: var(--stack-two-bg);
			border-radius: 50%;

			transition: 0.3s;
		}

		&::after {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);

			width: calc(100% + calc(var(--stack-width) * 1.6));
			height: calc(100% + calc(var(--stack-width) * 1.6));

			background: var(--stack-three-bg);
			border-radius: 50%;

			transition: 1s;
		}
	}

	.dashed-radius {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		width: calc(var(--step-end-size) * 2 + 2px);
		height: calc(var(--step-end-size) * 2 + 2px);

		border-radius: 50%;
		border: 2px dashed var(--color-surface);
	}

	.arrows-radius {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: ;

		width: 80.5%;
		height: 73.5%;

		border-radius: 35%;
		border-radius: 228.95px;
		/* border: 2px dashed red; */

		svg {
			position: absolute;

			width: ${({ factor }: Props) => factor * 294 + 'px'};
			height: ${({ factor }: Props) => factor * 135 + 'px'};

			overflow: visible;
			stroke: rgba(255, 255, 255, 0.5);
			/* stroke-width: 1; */
			stroke-linejoin: round;
			stroke-linecap: round;

			&.top-left {
				top: -8px;
				left: 20px;
			}

			&.top-right {
				top: -3px;
				right: 20px;
			}

			&.bottom-right {
				bottom: -8px;
				right: 20px;
			}

			&.bottom-left {
				bottom: -3px;
				left: 20px;
			}
		}
	}

	@keyframes stacks {
		0% {
			--stack-one-bg: transparent;
			--stack-two-bg: transparent;
			--stack-three-bg: transparent;
		}

		33% {
			--stack-one-bg: var(--stack-color);
		}

		66% {
			--stack-two-bg: var(--stack-color);
		}

		100% {
			--stack-three-bg: var(--stack-color);
		}
	}

	@keyframes rotate {
		0% {
			transform: translate(-50%, -50%) rotate(0deg);
		}

		100% {
			transform: translate(-50%, -50%) rotate(360deg);
		}
	}

	@media (max-width: 820px) {
		.step {
			&.step:not(.step-end) {
				&::before {
					/* top: 50%; */
				}
			}
		}
	}
`;

export default InfoGraphicHowItWorksContainer;
